import { useEffect, useState } from 'react';

/**
 * Delays a value until it stops changing.
 *
 * Used for table search boxes: without it, every keystroke becomes a request
 * and the backend's global throttler starts rejecting the user's own typing.
 */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
